import { getHTML } from "../../utilities/getHTML";
export function getSongHistory(song, count) {
    return new Promise((resolve) => {
        if (song.timesLead) {
            getHTML(song.historyLink)
                .then((html) => {
                const rows = html.querySelectorAll("tr");
                const history = [];
                for (let i = 0, l = rows.length; i < l; i++) {
                    const row = rows[i];
                    const cols = row.querySelectorAll("td");
                    if (cols.length) {
                        history.push({
                            date: cols[0].innerText,
                            service: cols[1].innerText,
                            leader: cols[2].innerText,
                        });
                    }
                }
                song.history = history;
                count.collected++;
                resolve(song);
            })
                .catch((e) => console.warn(e));
        }
        else {
            count.collected++;
            resolve(song);
        }
    });
}
